import { render } from "./CognitoLogin.vue?vue&type=template&id=4f26c986"
import script from "./CognitoLogin.vue?vue&type=script&lang=js"
export * from "./CognitoLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__